import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-howtostaysafe',
  templateUrl: './howtostaysafe.component.html',
  styleUrls: ['./howtostaysafe.component.css']
})
export class HowtostaysafeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
